import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import rainmatterLogo from "../images/investors-images/rainmatter-logo.png"

const RainmatterWide = () => (
  <img src={rainmatterLogo}/>
  // <StaticQuery
  //   query={graphql`
  //     query {
  //       placeholderImage: file(relativePath: { eq: "investors-images/rainmatter-logo.png" }) {
  //         childImageSharp {
  //           fluid(maxWidth: 3000) {
  //             ...GatsbyImageSharpFluid_noBase64
  //           }
  //         }
  //       }
  //     }
  //   `}
  //   render={data => <Img fluid={data.placeholderImage.childImageSharp.fluid} style={{width: '60%'}}/>}
  // />
)
export default RainmatterWide
